import ajax from "@/lib/ajax";
import config from "@/config";

// host
let HOST = undefined;
if (config.VUE_APP_ENV === 4) {
  HOST = config.host("", "/glycx");
} else {
  HOST = config.host("/pps", "/glycx");
}

// 查询单位管理员列表
const getUnitAdminList = (param) => {
  return ajax.get(`${HOST}/admin/unitAdminList`, param);
};

// 当前人员信息
const getUserInfo = (param) => {
  return ajax.get(`${HOST}/admin/userInfo`, param);
};

export { getUnitAdminList, getUserInfo };
